import { ListFill, NucleoProjects } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import FileEntity from '@/modules/tasks/file.entity';
import ProjectIcon from '@/modules/tasks/views/ProjectsDashboard/ProjectIcon';
import { FileSchema } from '@/types/schema';

const DEFAULT_ICON_SIZE = 20;

export function getStackIcon(
  name: string,
  iconSettings?: FileSchema['iconSettings'],
  size?: number,
  className?: string,
) {
  return (
    <ProjectIcon
      className={cn('shrink-0 rounded-4 text-icon-secondary', className)}
      iconSettings={iconSettings}
      name={name}
      size={size ?? DEFAULT_ICON_SIZE}
    />
  );
}

export function getListIcon(size?: number, className?: string) {
  return (
    <ListFill
      className={cn('flex-shrink-0', className)}
      height={size ?? DEFAULT_ICON_SIZE}
      width={size ?? DEFAULT_ICON_SIZE}
    />
  );
}

export function getProjectIcon(size?: number, className?: string) {
  return (
    <NucleoProjects
      className={cn('flex-shrink-0', className)}
      height={size ?? DEFAULT_ICON_SIZE}
      width={size ?? DEFAULT_ICON_SIZE}
    />
  );
}

// TODO: @aryan02420 replace getIcon in packages/apps/academy/src/@/modules/tasks/views/TasksDashboard/utils/getSidebarItems/index.tsx with this method
export function getFileIcon(
  file: Pick<FileSchema, 'name' | 'category' | 'projectStatus' | 'iconSettings'>,
  size?: number,
  className?: string,
) {
  if (FileEntity.isFileTypeStack(file)) {
    return getStackIcon(file.name, file.iconSettings, size, className);
  }

  if (FileEntity.isFileTypeList(file)) {
    return getListIcon(size, className);
  }

  if (FileEntity.isFileTypeProject(file)) {
    return getProjectIcon(size, className);
  }

  return <></>;
}
